import { render, staticRenderFns } from "./shagnchuan.vue?vue&type=template&id=f25ac258&scoped=true"
import script from "./shagnchuan.vue?vue&type=script&lang=js"
export * from "./shagnchuan.vue?vue&type=script&lang=js"
import style0 from "./shagnchuan.vue?vue&type=style&index=0&id=f25ac258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25ac258",
  null
  
)

export default component.exports